// ═══════════════════════════════════════════════════════════════════════════
// Mastery Challenges — one-time, run-condition-gated achievements
// ═══════════════════════════════════════════════════════════════════════════
// Distinct from daily/weekly quests (which rotate) and from the Heroes tab
// (which is repeatable + tied to a specific hero). Mastery Challenges are
// permanent feats that test specific run conditions: clear a zone fast,
// survive without deaths, run no potions, etc. Each is claimed once per
// account and rewards runes (Phase 1) — future phases will layer in tome
// / cosmetic rewards on top.
// ═══════════════════════════════════════════════════════════════════════════
export const MASTERY_CHALLENGES = [
    // ── Speed (gated to mid-game stages so easy Stage-1 zone clears
    //    don't trivially auto-claim them) ──
    { id: 'mastery_fast_zone_60', name: 'Speed Run', description: 'Clear a zone in 60 seconds or less (Stage 20+)', kind: 'fast_zone', target: 60, runes: 50, requiresStage: 20 },
    { id: 'mastery_fast_zone_30', name: 'Lightning', description: 'Clear a zone in 30 seconds or less (Stage 30+)', kind: 'fast_zone', target: 30, runes: 100, requiresStage: 30 },
    // ── Iron-man ──
    { id: 'mastery_no_death_20', name: 'Untouchable', description: 'Reach Stage 20 without losing a single hero', kind: 'no_death_to_stage', target: 20, runes: 75 },
    { id: 'mastery_no_death_40', name: 'Iron Will', description: 'Reach Stage 40 without losing a single hero', kind: 'no_death_to_stage', target: 40, runes: 200 },
    { id: 'mastery_no_potion_25', name: 'Sober Run', description: 'Reach Stage 25 without using a single potion', kind: 'no_potion_to_stage', target: 25, runes: 100 },
    { id: 'mastery_solo_25', name: 'Solo Champion', description: 'Reach Stage 25 with only one hero deployed', kind: 'solo_to_stage', target: 25, runes: 100 },
    // ── Stage gates ──
    { id: 'mastery_stage_30', name: 'Veteran', description: 'Reach Stage 30 in any run', kind: 'high_stage', target: 30, runes: 50 },
    { id: 'mastery_stage_50', name: 'Champion', description: 'Reach Stage 50 in any run', kind: 'high_stage', target: 50, runes: 150 },
    { id: 'mastery_stage_75', name: 'Legend', description: 'Reach Stage 75 in any run', kind: 'high_stage', target: 75, runes: 300 },
    // ── Boss feats ──
    { id: 'mastery_bosses_5', name: 'Boss Crusher', description: 'Defeat 5 zone bosses in a single run', kind: 'bosses_in_run', target: 5, runes: 75 },
    { id: 'mastery_bosses_10', name: 'Boss Annihilator', description: 'Defeat 10 zone bosses in a single run', kind: 'bosses_in_run', target: 10, runes: 200 },
    // ── Inferno ──
    { id: 'mastery_inferno_5', name: 'Inferno Diver', description: 'Reach Inferno Zone 5', kind: 'inferno_zone', target: 5, runes: 200, requiresInferno: true },
    { id: 'mastery_inferno_10', name: 'Hellforged', description: 'Reach Inferno Zone 10', kind: 'inferno_zone', target: 10, runes: 400, requiresInferno: true },
];
/** Lookup by id — used by the UI for tooltips and by the manager for claim. */
const BY_ID = (() => {
    const m = {};
    for (const c of MASTERY_CHALLENGES)
        m[c.id] = c;
    return m;
})();
export function getMasteryChallenge(id) {
    return BY_ID[id];
}
//# sourceMappingURL=masteryChallenges.js.map